import { HTMLProps, ReactNode } from 'react'
import { cva, type VariantProps, cx } from 'class-variance-authority'

const titleBase = cva(['font-sans'], {
    variants: {
        weight: {
            normal: 'font-normal',
            medium: 'font-medium',
            semibold: 'font-semibold',
            bold: 'font-bold'
        },
        color: {
            primary: 'text-textPrimary',
            brand: 'text-textBrand',
            darkGrey: 'text-textSecondary',
            lightGrey: 'text-textTertiary',
            light: 'text-textOnColor',
            positive: 'text-textPositive',
            negative: 'text-textNegative',
            warning: 'text-textWarning'
        }
    },
    defaultVariants: {
        weight: 'semibold'
    }
})

type TitleProps = HTMLProps<HTMLHeadingElement> &
    VariantProps<typeof titleBase> & {
        children: ReactNode
    }

const TripleXl = ({ children, weight, color, className, ...props }: TitleProps) => {
    return (
        <h1 className={cx('text-3xl', titleBase({ weight, color }), className)} {...props}>
            {children}
        </h1>
    )
}

const TwoXl = ({ children, weight, color, className, ...props }: TitleProps) => {
    return (
        <h1 className={cx('text-2xl', titleBase({ weight, color }), className)} {...props}>
            {children}
        </h1>
    )
}

const Xl = ({ children, weight, color, className, ...props }: TitleProps) => {
    return (
        <h1 className={cx('text-xl', titleBase({ weight, color }), className)} {...props}>
            {children}
        </h1>
    )
}

const Lg = ({ children, weight = 'medium', color, className, ...props }: TitleProps) => {
    return (
        <h1 className={cx('text-lg', titleBase({ weight, color }), className)} {...props}>
            {children}
        </h1>
    )
}

export default { TripleXl, TwoXl, Xl, Lg }
